<template>
	<div id="page_4">
		<div class="title">
			<p>产品&amp;服务</p>
			<p class="sub">我们以用户的需求主导产品研发，提供丰富、高性能、稳定的产品和服务</p>
		</div>
		<el-row :gutter="20">
		  <el-col :span="6" v-for="(item,i) in cardList" :key="i">
		  	<div class="card" @mouseover="update(item)" @mouseout="update(item)">
				<img :src="item.img"/>
				<div>
					<p>{{item.name}}</p>
					<p>{{item.desc}}</p>
				</div>
		  	</div>
		  </el-col>
		</el-row>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				cardList: [{
						"name": "物联网连接服务",
						"desc": "稳定灵活适应业务需求",
						"img": require('@/assets/img/home/4_1.png'),
						"img_hover": require("@/assets/img/home/4_1_hover.png")
					},
					{
						"name": "云服务器",
						"desc": "三高特性云服务器",
						"img": require('@/assets/img/home/4_2.png'),
						"img_hover": require("@/assets/img/home/4_2_hover.png")
					},
					{
						"name": "大数据分析",
						"desc": "大规模并行处理数据",
						"img": require('@/assets/img/home/4_3.png'),
						"img_hover": require("@/assets/img/home/4_3_hover.png")
					},
					{
						"name": "APP制定开发",
						"desc": "为电器智能控制项目加速",
						"img": require('@/assets/img/home/4_4.png'),
						"img_hover": require("@/assets/img/home/4_4_hover.png")
					},
				]
			}
		},
		computed: {},
		methods: {
			update: function(item) {
				var temp = item.img;
				item.img = item.img_hover;
				item.img_hover = temp;
			},
		},
		components: {},
		created() {}
	}
</script>
<style lang="less">
	@import url("../../assets/common.less");
	#page_4 {
		.page();
		&>.title {
			.page_title();
		}
		& > .el-row{
			overflow: hidden;
			position: absolute;
			top: 45vh;
			bottom: auto;
			left: 10vw;
			right: 10vw;
			width: 80vw;
			.card{
				padding: 30px;
				border: 1px solid #aaa;
				text-align: center;
				color: #8391a5;
				&:hover {
					border: 1px solid @theme-color;
					color: @theme-color;
				}
				&>img {
					width: 50%;
				}
				&>div {
					p:nth-of-type(1) {
						font-size: 1.2em;
						line-height: 2em;
					}
					p:nth-of-type(2) {
						font-size: 0.8em;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// page_4.vue?750a6edc